module.exports = __webpack_public_path__ + "static/img/googlecalendar3.f6d1a39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/googlecalendar3.png
// module id = 1424
// module chunks = 1